// Global JS for the theme

// Update cart count badge
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cart-count');
    if (badge) badge.textContent = cart.item_count;
  } catch (e) {}
}

// Add to cart form — prevent default and use AJAX
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('add-to-cart-form');
  if (!form) return;

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn.innerHTML;
    btn.innerHTML = '⏳ Ajout en cours...';
    btn.disabled = true;

    try {
      const formData = new FormData(form);
      const qtyInput = document.getElementById('quantity');
      if (qtyInput) formData.set('quantity', qtyInput.value);

      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (res.ok) {
        btn.innerHTML = '✅ Ajouté au panier !';
        btn.style.background = '#3E6B4A';
        updateCartCount();
        setTimeout(() => {
          btn.innerHTML = originalText;
          btn.style.background = '';
          btn.disabled = false;
        }, 2000);
      } else {
        throw new Error('Erreur ajout panier');
      }
    } catch (err) {
      btn.innerHTML = '❌ Erreur, réessayez';
      setTimeout(() => {
        btn.innerHTML = originalText;
        btn.disabled = false;
      }, 2000);
    }
  });
});

// Initialize
updateCartCount();
